/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

/**
 * A constant indicating a type of comparison that NgSwitch uses to match cases. Extracted to a
 * separate file to facilitate G3 patches.
 */
export const NG_SWITCH_USE_STRICT_EQUALS = true;
